import { InsuranceState } from '../types';

interface State {
  insurance: InsuranceState;
}

const vendorOpportunity = (state: State) => state.insurance.vendorOpportunity;
const creditApplication = (state: State) => state.insurance.creditApplication;
const submissions = (state: State) => state.insurance.submissions;
const isInsuranceExpressIntegrated = (state: State) => state.insurance.isInsuranceExpressIntegrated;
const proposals = (state: State) => state.insurance.proposals;
const financePrograms = (state: State) => state.insurance.financePrograms;

const selectedSubmission = (state: State) => state.insurance.selectedSubmission;
const selectedFinanceProgram = (state: State) => state.insurance.selectedFinanceProgram;

const stepperConfig = (state: State) => state.insurance.stepperConfig;
const accordionConfig = (state: State) => state.insurance.accordionConfig;
const coverageStatusConfig = (state: State) => state.insurance.coverageStatusConfig;

const insuranceBroker = (state: State) => state.insurance.insuranceBroker;
const insuranceVerificationTask = (state: State) => state.insurance.insuranceVerificationTask;
const insuranceCertificate = (state: State) => state.insurance.insuranceCertificate;

export const insuranceSelector = {
  vendorOpportunity,
  creditApplication,
  submissions,
  isInsuranceExpressIntegrated,
  proposals,
  financePrograms,
  selectedSubmission,
  selectedFinanceProgram,
  stepperConfig,
  accordionConfig,
  coverageStatusConfig,
  insuranceBroker,
  insuranceVerificationTask,
  insuranceCertificate,
};
